import { Checkbox, message, Modal, Spin } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { TLinkSource } from "components/feature-entity-linking-page/models";
import { getFeatureDetail } from "components/feature-entity-linking-page/utils";
import { generateLinkingPayload } from "components/feature-entity-linking-page/utils/generate-payload";
import { ErrorMessages, SuccessMessages } from "constants/index";
import { ProjectContext } from "context/ProjectProvider";
import { FeatureTypes } from "entity-app/constants";
import { useCIQMutation } from "hooks/ciq-gql-hooks";
import { useContext, useState } from "react";
import { MUTATION_APPLY_LINKING_CHANGES } from "services/graphQL/mutations";

export default function ActivityTrackingCheckbox({
  submittalIds,
  list,
  refetchEntityInfo,
  checked,
  setChecked
}: {
  list: TLinkSource[];
  submittalIds: string[];
  refetchEntityInfo: () => Promise<void>;
  checked: boolean;
  setChecked: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [loading, setLoading] = useState(false);

  const { gqlClientForProject } = useContext(ProjectContext);

  const [linkingMutation] = useCIQMutation(MUTATION_APPLY_LINKING_CHANGES, {
    client: gqlClientForProject
  });

  const handleSave = async () => {
    const oldEntityLinks: TLinkSource[] = list;
    const newEntityLinks: TLinkSource[] = [];

    const payload = generateLinkingPayload({
      selectedEntityInfo: {
        ids: submittalIds,
        parentFeatureDetail: getFeatureDetail(FeatureTypes.SUBMITTALS).feature
      },
      oldEntityLinks,
      newEntityLinks,
      cardsFeatureName: "SCHEDULES"
    });

    const payloadData = {
      input: {
        inserts: payload.inserts,
        deletes: payload.deletes,
        updates: []
      },
      metadata: {
        request_source: "LINKING_PAGE"
      }
    };

    const linkingResponse = await linkingMutation({
      variables: payloadData
    });

    if (linkingResponse?.data) {
      message.success(SuccessMessages.SuccessfullyUpdate);

      await refetchEntityInfo();
    } else {
      message.error(ErrorMessages.SomethingWentWrong);
    }
  };

  const toggleActivityLinking = (e: CheckboxChangeEvent) => {
    if (!e.target.checked && list.length) {
      Modal.confirm({
        title: "Disable Linking to Activities?",
        content: "All the linked Activities will be removed.",
        className: "skip-listing-window custom-rounded-modal",
        async onOk() {
          setLoading(true);
          await handleSave();
          setChecked(false);
          setLoading(false);
        },
        okText: "Yes, disable"
      });
    } else {
      setChecked(e.target.checked);
    }
  };

  return (
    <Spin spinning={loading}>
      <Checkbox
        checked={checked}
        onChange={toggleActivityLinking}
        data-testid="activitytrackingchechbox-checkbox"
      >
        Link Submittal to Activities
      </Checkbox>
    </Spin>
  );
}
